import React from "react";

const industries = [
  { title: "Residential Homes", detail: "Villas, bungalows, and independent houses.",
    img: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?q=80&w=1200&auto=format&fit=crop" },
  { title: "High-Rise Societies", detail: "20+ floor towers with multi-tank hydraulics.",
    img: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxoaWdoJTIwcmlzZSUyMGFwYXJ0bWVudCUyMGJ1aWxkaW5nfGVufDB8fHx8MTc4MzI1NzAyM3ww&ixlib=rb-4.1.0&q=85" },
  { title: "Factories & Plants", detail: "Industrial process water & cooling loops.",
    img: "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?q=80&w=1200&auto=format&fit=crop" },
  { title: "Shopping Malls", detail: "Retail complexes, food courts, sanitation.",
    img: "https://images.unsplash.com/photo-1519567241046-7f570eee3ce6?q=80&w=1200&auto=format&fit=crop" },
  { title: "Hospitals", detail: "Life-safety water supply with redundancy.",
    img: "https://images.unsplash.com/photo-1587351021759-3e566b6af7cc?q=80&w=1200&auto=format&fit=crop" },
  { title: "Government Buildings", detail: "Municipal, defence, PSU installations.",
    img: "https://images.unsplash.com/photo-1541872703-74c5e44368f9?q=80&w=1200&auto=format&fit=crop" },
];

export default function Industries() {
  return (
    <section id="industries" className="border-b border-zinc-200 bg-[#0A0A0A] text-white">
      <div className="px-6 md:px-12 lg:px-24 py-24 md:py-32">
        <div className="max-w-3xl mb-16">
          <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#FF5F1F] mb-4">
            /// Industries We Serve
          </div>
          <h2 className="text-4xl sm:text-5xl font-semibold tracking-tight leading-tight">
            Every drop counts. Everywhere.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((i) => (
            <div
              key={i.title}
              className="group relative overflow-hidden border border-zinc-800 bg-zinc-900"
            >
              <img
                src={i.img}
                alt={i.title}
                className="w-full h-56 object-cover opacity-60 group-hover:opacity-80 group-hover:scale-105 transition-all duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="text-xl font-semibold tracking-tight">{i.title}</h3>
                <p className="text-sm text-zinc-300 mt-1">{i.detail}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
